import type { App } from 'vue';
import FloatingVue from 'floating-vue';

export function installFloatingVue(app: App) {
  app.use(FloatingVue, {
    themes: {
      findandselect: {
        $extend: 'dropdown',
        triggers: [],
        autoHide: false,
        autoSize: 'min',
      },
      annotation: {
        $extend: 'dropdown',
        placement: 'right-start',
        distance: 8,
      },
      marker: {
        $extend: 'tooltip',
        placement: 'right',
      },
      dark: {
        $extend: 'tooltip',
      },
      quoteAction: {
        $extend: 'dropdown',
        distance: 16,
      },
    },
  });
}
